module.exports = "<script type=\"text/html\" id=\"survey-question-html\">\n  <div data-bind=\"html: question.locHtml.koRenderedHtml, css: question.koCss().root\"></div>\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/templates/question-html.html
// module id = 89
// module chunks = 0